/*global my_ajax_object*/

export default function UpdateData( block ) {

	const updateBtn = block.querySelector( '.js-update-duw' );
	const cancelBtn = block.querySelector( '.js-cancel-duw' );
	const form = block.querySelector( 'form' );
	const fieldValue = block.querySelector( '.js-field-value' );

	this.openForm = () => {
		
		form.removeAttribute( 'hidden' );
		updateBtn.setAttribute( 'hidden', true );
		cancelBtn.removeAttribute( 'hidden' );
		fieldValue.setAttribute( 'hidden', true );

		// focus on first input
		form.querySelector( 'input, select' ).focus();
	}

	this.cancel = () => {
		form.setAttribute( 'hidden', true );
		cancelBtn.setAttribute( 'hidden', true );
		updateBtn.removeAttribute( 'hidden' );
		fieldValue.removeAttribute( 'hidden' );

		// focus on update button
		updateBtn.focus();
	}

	this.closeForm = () => {

		form.setAttribute( 'hidden', true );
		cancelBtn.setAttribute( 'hidden', true );
		updateBtn.removeAttribute( 'hidden' );
		fieldValue.removeAttribute( 'hidden' );

		// focus on result
		fieldValue.focus();
	}

	/* MARK: submit */
	this.submitForm = () => {

		const submitButton = form.querySelector( 'input[type=submit]' );

		const action = form.dataset.action;
		const ajaxurl = my_ajax_object.ajax_url;
		const nonce = my_ajax_object.nonce;

		const data = new FormData( form );
		data.append( 'action', action );
		data.append( 'nonce', nonce );

		const cancerTypes = [];
		const speciality = [];
		const institutes = [];

		form.querySelectorAll( 'input[name="patient.condition.body_site"]:checked' ).forEach( ( checkbox ) => {
			cancerTypes.push( checkbox.getAttribute( 'value' ) );
		} );

		form.querySelectorAll( 'input[name="patient.pro_specialty"]:checked' ).forEach( ( checkbox ) => {
			if ( checkbox.getAttribute( 'value' ) != "" && checkbox.getAttribute( 'value' ) != "autre" ) {
				speciality.push( checkbox.getAttribute( 'value' ) );
			}
		} );

		form.querySelectorAll( 'input[name="patient.pro_institute"]:checked' ).forEach( ( checkbox ) => {
			if ( checkbox.getAttribute( 'value' ) != "" && checkbox.getAttribute( 'value' ) != "autre" ) {
				institutes.push( checkbox.getAttribute( 'value' ) );
			}
		} );


		data.set( 'patient.condition.body_site', cancerTypes );
		data.set( 'patient.pro_specialty', speciality );
		data.set( 'patient.pro_institute', institutes );

		

		const ms = document.querySelector( '.form-status' );
		ms.innerHTML = "Traitement en cours";
		form.querySelector( '.formResultMessage' ).innerHTML = "";
		form.querySelector( '.formErrorMessage' ).innerHTML = "";

		fetch( ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache',
			},
			body: new URLSearchParams( data ),
		} )
			.then( response => response.json() )
			.then( body => {

				ms.innerHTML = "";
				submitButton.classList.remove( 'loading' );

				const result_div = document.createElement( 'div' );
				const result_p = document.createElement( 'p' );
				result_p.innerHTML = body.data;
				result_div.append( result_p );

				if ( body.success ) {

					if ( action === "update_account_password" || action === "update_account_subscription" || action === "delete_account") {

						form.querySelector( '.formResultMessage' ).appendChild( result_div );
						form.querySelector( '.formResultMessage' ).focus();

					} else {

						fieldValue.innerHTML = body.data;
						this.closeForm();

					}

				} else {
					form.querySelector( '.formErrorMessage' ).appendChild( result_div );
					form.querySelector( '.formErrorMessage' ).focus();
				}

			} )
			.catch( ( error ) => {

				const result_div = document.createElement( 'div' );
				const result_p = document.createElement( 'p' );
				result_p.innerHTML = error;
				result_div.append( result_p );

				form.querySelector( '.formErrorMessage' ).appendChild( result_div );
				form.querySelector( '.formErrorMessage' ).focus();

			} );

	}

	this.showConditionnalBlock = ( group ) => {
		group.forEach( ( g ) => {
			g.removeAttribute( "hidden" );
		} );
	};

	this.hideConditionnalBlock = ( group ) => {
		group.forEach( ( g ) => {
			g.setAttribute( "hidden", "" );
		} );
	};


	this.showConditionnalFields = ( group ) => {
		group.forEach( ( g ) => {
			const fields = g.querySelectorAll( 'input, select' );
			fields.forEach( ( f ) => {
				f.removeAttribute( "aria-disabled" );
			} );
			g.removeAttribute( "hidden" );
		} );
	};

	this.hideConditionnalFields = ( group ) => {
		group.forEach( ( g ) => {
			g.setAttribute( "hidden", "" );
			const fields = g.querySelectorAll( 'input, select' );
			fields.forEach( ( f ) => {
				f.setAttribute( "aria-disabled", true );

				if ( f.getAttribute( 'type' ) === "text" ) {
					f.setAttribute( "value", "" );
				}

				if ( f.dataset.type === "select" ) {
					f.selectedIndex = 0;
				}

				f.checked = false;

			} );
		} );
	};


	this.init = () => {

		if ( updateBtn ) updateBtn.addEventListener( 'click', this.openForm );
		if ( cancelBtn ) cancelBtn.addEventListener( 'click', this.cancel );


		document.querySelector( '.js-status' ).addEventListener( "change", ( e ) => {
			if ( e.target.value == "ACTIVE" || e.target.value == "INACTIVE" ) {
				this.showConditionnalBlock( document.querySelectorAll( '.js-status-result' ) );
			} else {
				this.hideConditionnalBlock( document.querySelectorAll( '.js-status-result' ) );
			}
		} );

		document.querySelectorAll( '.js-type' ).forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				if ( e.target.checked ) {
					this.showConditionnalFields( document.querySelectorAll( '.js-type-result' ) );
				} else {
					this.hideConditionnalFields( document.querySelectorAll( '.js-type-result' ) );
				}
			} );
		} );

		document.querySelector( '.js-pro' ).addEventListener( "change", ( e ) => {
			if ( e.target.value == "true" ) {
				this.showConditionnalBlock( document.querySelectorAll( '.js-pro-result' ) );
			} else {
				this.hideConditionnalBlock( document.querySelectorAll( '.js-pro-result, .js-pro-result-hide' ) );
			}
		} );

		document.querySelector( '.js-pro-spe' ).addEventListener( "change", ( e ) => {
			if ( e.target.checked ) {
				this.showConditionnalFields( document.querySelectorAll( '.js-pro-spe-result' ) );
			} else {
				this.hideConditionnalFields( document.querySelectorAll( '.js-pro-spe-result' ) );
			}
		} );

		const allJsChercheur = document.querySelectorAll( '.js-chercheur' );

		allJsChercheur.forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				let checkedSpe = document.querySelectorAll( '.js-chercheur:checked' );

				if ( e.target.checked ) {
					this.showConditionnalBlock( document.querySelectorAll( '.js-chercheur-result' ) );
				} else {
					if ( checkedSpe.length < 1 ) {
						this.hideConditionnalBlock( document.querySelectorAll( '.js-chercheur-result' ) );
					}
				}
			} );
		} );

		document.querySelector( '.js-pro-institute' ).addEventListener( "change", ( e ) => {
			if ( e.target.checked || e.target.value == "autre" ) {
				this.showConditionnalFields( document.querySelectorAll( '.js-pro-institute-result' ) );
			} else {
				this.hideConditionnalFields( document.querySelectorAll( '.js-pro-institute-result' ) );
			}
		} );

		document.querySelectorAll( '.js-psc' ).forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				if ( e.target.value == "99" ) {
					this.showConditionnalFields( document.querySelectorAll( '.js-psc-result' ) );
				} else {
					this.hideConditionnalFields( document.querySelectorAll( '.js-psc-result' ) );
				}
			} );
		} );

		document.querySelectorAll( '.js-level' ).forEach( ( elt ) => {
			elt.addEventListener( "change", ( e ) => {
				if ( e.target.value == "99" ) {
					this.showConditionnalFields( document.querySelectorAll( '.js-level-result' ) );
				} else {
					this.hideConditionnalFields( document.querySelectorAll( '.js-level-result' ) );
				}
			} );
		} );

		const validator = new ValidateUpdateData( form );
		form.addEventListener( 'submit', ( e ) => validator.validateForm( e ) );
		form.addEventListener( 'validated', () => {

			this.submitForm();
		} );
	}
}


/* MARK: FORM */

function ValidateUpdateData( form ) {

	const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
	const passwordRegex = /^(?=.*\d)(?=.*\W)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,32}$/;
	const yearRegex = /^\d{4}$/;
	const postalCodeRegex = /^(?:0[1-9]|00[1-9]|[1-9]{2}|[1-9]0)\d{2,3}$/;
	const telRegex = /^[+]?[\s/0-9]{10,17}$/;
	const blackList = document.querySelector( '.bl' ).innerText.split( ',' );

	const emailErrorMessage = document.querySelector( '.message-email' ).innerHTML;
	const emailConfirmErrorMessage = document.querySelector( '.message-emailConfirm' ).innerHTML;
	const mdpConfirmErrorMessage = document.querySelector( '.message-mdpConfirm' ).innerHTML;
	const emailBlackListErrorMessage = document.querySelector( '.message-blackList' ).innerHTML;
	const requiredErrorMessage = "Veuillez renseigner ce champ.";
	const yearErrorMessage = document.querySelector( '.message-yearError' ).innerHTML;
	const yearDateErrorMessage = document.querySelector( '.message-yearDateError' ).innerHTML;
	const postalCodeErrorMessage = document.querySelector( '.message-postalCode' ).innerHTML;
	const phoneCodeErrorMessage = document.querySelector( '.message-phone' ).innerHTML;


	const submitButton = form.querySelector( 'input[type=submit]' );

	/* MARK: validate form */
	this.validateForm = ( e ) => {

		// prevent submit
		e.preventDefault();
		e.stopImmediatePropagation();

		if ( submitButton.classList.contains( 'loading' ) ) return;

		// prevent new submit
		submitButton.classList.add( 'loading' );

		let nbError = 0;
		const fields = Array.from( form.querySelectorAll( 'input, select' ) );
		this.reset( fields );

		// check fields
		fields.forEach( ( f ) => {
			if ( f.getAttribute( 'type' ) === 'email' ) {
				if ( !this.validateEmail( f ) ) {
					nbError += 1;
				}
			} else if ( f.getAttribute( "name" ) === "patient.birth_date" ) {
				if ( !this.validateBirthYear( f ) ) {
					nbError += 1;
				}
			} else if ( f.getAttribute( "type" ) === "tel" ) {
				if ( !this.validatePhone( f ) ) {
					nbError += 1;
				}
			} else if ( f.getAttribute( "name" ) === "patient.address.zip_code" ) {
				if ( !this.validatePostalCode( f ) ) {
					nbError += 1;
				}
			} else if ( f.dataset.type === 'password' ) {
				if ( !this.validatePassword( f ) ) {
					nbError += 1;
				}
			} else if ( f.dataset.type === 'password-confirm' ) {

				if ( f.value !== form.querySelector( '.js-base-mdp' ).value ) {
					f.setCustomValidity( mdpConfirmErrorMessage );
					this.unvalidateField( f );
					nbError += 1;
				}

			} else {

				if ( f.dataset.type === 'js-no-numbers' ) {
					const cleaned = f.value.replace( /(\d)*/g, '' );
					f.value = cleaned;
				}

				if ( !f.checkValidity() ) {
					this.unvalidateField( f );
					nbError += 1;
				}
			}
		} );

		if ( nbError > 0 ) {
			// not OK

			submitButton.classList.remove( 'loading' );

			//focus sur le premier input faux
			const firstInvalidField = form.querySelector( '[aria-invalid="true"]' );

			if ( firstInvalidField ) {
				firstInvalidField.focus();
			}

		} else {
			// OK
			form.dispatchEvent( new Event( 'validated' ) );
		}

	}



	/* MARK: validate phone */
	this.validatePhone = ( field ) => {

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		const tel_corrected = field.value.replace( /([-.()])*/g, '' );
		field.value = tel_corrected;

		if ( field.value.match( /\d/g ).length < 10 || field.value.match( /\d/g ).length > 17 ) {
			field.setCustomValidity( phoneCodeErrorMessage );
			this.unvalidateField( field );
		}

		if ( !telRegex.test( field.value ) ) {
			field.setCustomValidity( phoneCodeErrorMessage );
			this.unvalidateField( field );
			return false;
		}
		return true;
	};

	/* MARK: validate postal code */
	this.validatePostalCode = ( field ) => {
		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooShort ) {
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooLong ) {
			this.unvalidateField( field );
			return false;
		}

		if ( !postalCodeRegex.test( field.value ) ) {
			field.setCustomValidity( postalCodeErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		return true;

	};

	/* MARK: validate birth year */
	this.validateBirthYear = ( field ) => {
		const currentYear = new Date().getFullYear();
		const birth_date_min = currentYear - 100;
		const birth_date_max = currentYear - 17;

		// Correct data if needed 
		let currentVal = field.value;
		currentVal = currentVal.trim();
		currentVal = currentVal.replace( /\s/g, '' );

		field.value = currentVal;

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooShort ) {
			this.unvalidateField( field );
			return false;
		}

		if ( field.validity.tooLong ) {
			this.unvalidateField( field );
			return false;
		}

		if ( !yearRegex.test( field.value ) ) {
			field.setCustomValidity( yearErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( field.value > birth_date_max || field.value < birth_date_min ) {
			field.setCustomValidity( yearDateErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		return true;

	};

	/* MARK: validate email */
	this.validateEmail = ( field ) => {

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		if ( !emailRegex.test( field.value ) ) {
			field.setCustomValidity( emailErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		// Check black List
		if ( document.querySelector( '.bl' ) ) {
			if ( blackList.includes( field.value.split( "@" ).pop() ) ) {
				field.setCustomValidity( emailBlackListErrorMessage );
				this.unvalidateField( field );
				return false;
			}
		}

		if ( field.classList.contains( 'js-confirm-email' ) ) {
			if ( field.value !== this.currentStep.querySelector( '.js-base-email' ).value ) {
				field.setCustomValidity( emailConfirmErrorMessage );
				this.unvalidateField( field );
				return false;
			}
		}

		return true;
	};

	/* MARK: validate password */
	this.validatePassword = ( field ) => {

		if ( field.validity.valueMissing ) {
			field.setCustomValidity( requiredErrorMessage );
			this.unvalidateField( field );
			return false;
		}

		let passOk = true;
		let mess = "<div>Le mot de passe doit contenir au moins : <ul>";

		//validationMessage

		if ( field.validity.tooShort ) {
			mess += "<li>8 caractères</li> ";
			passOk = false;
		}

		if ( field.validity.tooLong ) {
			mess += "<li>moins de 32 caractères</li> ";
			passOk = false;
		}

		if ( !passwordRegex.test( field.value ) ) {

			if ( !field.value.match( /[a-z]/g ) ) {
				mess += "<li>une lettre minuscule</li> ";
			}

			if ( !field.value.match( /[A-Z]/g ) ) {
				mess += "<li>une lettre majuscule</li> ";
			}

			if ( !field.value.match( /[0-9]/g ) ) {
				mess += "<li>un chiffre</li> ";
			}

			if ( !field.value.match( /[?=.*\W]/g ) ) {
				mess += "<li>un caractère spécial</li> ";
			}


			mess += "</ul></div>";

			passOk = false;
		}

		if ( !passOk ) {
			field.setCustomValidity( mess );
			this.unvalidateField( field );
			return false;
		}

		return true;

	};

	/* MARK: validate	*/
	this.validateField = ( f ) => {
		let parent = f.parentElement;
		if ( f.getAttribute( 'type' ) === 'password' || f.dataset.type === "password" || f.dataset.type === "password-confirm" || f.tagName == "SELECT" ) {
			parent = f.parentElement.parentElement;
		}

		if ( f.classList.contains( 'toggle__input' ) ) {
			parent = f.parentElement.parentElement.parentElement;
		}

		f.setCustomValidity( '' );
		f.setAttribute( 'aria-invalid', false );
		if ( parent.querySelector( '.indiError' ) ) {
			parent.querySelector( '.indiError' ).remove();
		}

		// restor correct describded-by
		if ( f.getAttribute( 'aria-describedby' ) ) {
			f.setAttribute( 'aria-describedby', f.dataset.describedby );
		}
	};

	/* MARK: unvalidate	*/
	this.unvalidateField = ( f ) => {
		f.setAttribute( 'aria-invalid', true );
		this.addErrorToField( f );
	};

	/* MARK: add error	*/
	this.addErrorToField = ( f, c = '' ) => {
		let parent = f.parentElement;

		if ( f.dataset.type === "password" || f.dataset.type === "password-confirm" || f.tagName == "SELECT" ) {
			parent = f.parentElement.parentElement;
		}

		if ( f.classList.contains( 'toggle__input' ) ) {
			parent = f.parentElement.parentElement.parentElement;
		}

		const errorId = `error_${f.getAttribute( 'name' )}`;
		const errorBlock = document.createElement( 'div' );
		errorBlock.id = errorId;
		errorBlock.setAttribute( 'tabindex', '-1' );
		errorBlock.className = `indiError ${c}`;
		errorBlock.innerHTML = `${this.getErrorMessage( f )}`;

		let oldDescribed = f.getAttribute( 'aria-describedby' );
		f.setAttribute( 'aria-describedby', `${errorId} ${oldDescribed}` );


		if ( parent.querySelector( "label" ) ) {
			parent.querySelector( "label" ).after( errorBlock );
		} else {
			parent.prepend( errorBlock );
		}

	};

	this.getErrorMessage = ( f ) => {
		let em = f.validationMessage;
		return em;
	};

	/* MARK: reset	*/
	this.reset = ( fields ) => {
		fields.forEach( ( f ) => {
			if ( f.getAttribute( 'type' ) !== 'submit' && f.getAttribute( 'type' ) !== 'hidden' ) {
				this.validateField( f );
			}
		} );
	};


	/* MARK: Check Email Exist */

	this.checkEmailExist = ( field ) => {
		const action = "checkEmailExist";
		const ajaxurl = my_ajax_object.ajax_url;
		const nonce = my_ajax_object.nonce;

		const data = {
			action: action,
			nonce: nonce,
			mail: field.value
		};

		return fetch( ajaxurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'Cache-Control': 'no-cache',
			},
			body: new URLSearchParams( data ),
		} )
			.then( response => response.json() )
			.then( body => {
				return !!( body.success );
			} );
	};

}